const contractAddress = "0x34A213755eFca4952DE2BC35E308d1Ddc931e001" // nft

export default contractAddress